import { useQueryWithUserId } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';

/**
 * This query key is used to track the list of inbound types.
 */
const INBOUND_TYPES_LIST_KEY = 'inbound-transaction-type-list-query';

/**
 * This useQuery hook fetches the list of inbound types from the API
 */
export const useFetchInboundTypesQuery = (enabled: boolean) => {
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    enabled,
    queryKey: [INBOUND_TYPES_LIST_KEY],
    networkMode: 'always',
    queryFn: INBOUND_API.fetchInboundTypesList,
  });

  return {
    error,
    isError,
    data,
    isPending,
    refetchInboundTypes: refetch,
  };
};
